import React, { useState } from "react";
import { useAuth } from "../context/auth";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useTryon } from "../context/TryOnContext";
const AddtoTryOn = ({ p_id }) => {
  const [auth] = useAuth();
  const [resMsg, setResMsg] = useState({});
  const [wishCls, setWishCls] = useState("");
  const [wishAlert, setWishAlert] = useState("");
  const { tryon, addToTryon } = useTryon();
  const navigate = useNavigate();

  const handleTryOn = async (p_id) => {
    setResMsg({});
    try {
      if (!auth.user) {
        setWishAlert(true);
        setTimeout(function () {
          setWishAlert(false);
        }, 5000);
        //alert('Please login!')
        //setResMsg({cls:'text-danger', msg:'Please login!'});
        return false;
      }

      const isInWishlist = tryon?.list?.some((item) => item.product_id === p_id);

      if (isInWishlist) {
        navigate('/tryondetail');
      } else {
        setWishCls("loading-wishlist");
        const data = await addToTryon(auth.user.id, p_id);
        if (data.status) {
          setResMsg({ cls: "text-success", msg: "Added successfully!" });
          setTimeout(function () {
            setResMsg({});
          }, 3000);
          setWishCls("completed");
        } else if (!data.status) {
          setResMsg({ cls: "text-danger", msg: "Already added!" });
          setWishCls("not-completed");
          setTimeout(function () {
            setResMsg({});
          }, 3000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeBtn = () => {
    setWishAlert(false);
    return false;
  };
  return (
    <>
      <button 
        type="button"
        className={`try-btn ${tryon?.list?.some((item) => item.product_id === p_id)
            ? "completed"
            : ""
          }`}
        onClick={() => handleTryOn(p_id)}
      >
        {tryon?.list?.some((item) => item.product_id === p_id) ? (
          <><i className="fa-solid fa-check"></i> TRY THE LOOK</>
        ) : (
          <>TRY THE LOOK</>
        )}
      </button>

      {resMsg?.msg && <div className={`${resMsg.cls}`}>{resMsg.msg}</div>}

      {wishAlert && (
        <>
          <div className="login-div">
            <span className="close-login-div" onClick={closeBtn}>
              &times;
            </span>
            You need to login to AI tryon the product.{" "}
            <Link to="/loginsignup">Log In/Sign up</Link>
          </div>
          <div className="login-div-overlay"></div>
        </>
      )}
    </>
  );
};

export default AddtoTryOn;
